import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material";
import { DadosTitulosItems } from "..";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useState } from "react";
import DialogEdit from "./DialogEdit";
import { IDetalharTituloPagar } from "../../../../../../../types/api/financeiro/detalhar-titulo-pagar";
import { usePermission } from "../../../../../../../components/PermissionGuard";

export default function CardDadosTitulo({ boxStyle, detalhe, codigo }: CardDadosTituloProps) {

    const podeEditar = usePermission('financeiro.contas-receber-editar')
    const [openEdit, setOpenEdit] = useState(false)

    return (
        <Box {...boxStyle}>
            <Typography variant="h6">Dados do título</Typography>

            <Grid container rowGap={2}>
                <Grid size={{xs: 6}}>
                    <DadosTitulosItems 
                        titulo="Público" 
                        valor={detalhe.publico ? `${detalhe.publico?.tipo_publico}${detalhe.publico?.codigo_publico} - ${detalhe.publico?.nome_pessoa}` : "-"} 
                    />
                </Grid>
                
                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems 
                        titulo="Tipo" 
                        valor={detalhe.tipo ? `${detalhe.tipo?.id} - ${detalhe.tipo?.nome}` : "-"} 
                    />
                </Grid>

                <Grid size={{xs: 6, md: 3}}>
                    <DadosTitulosItems titulo="Tipo D/C" valor={`${detalhe.tipo_debito_credito}`} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems 
                        titulo="Departamento" 
                        valor={detalhe.departamento ? `${detalhe.departamento?.id} - ${detalhe.departamento?.nome}` : "-"} 
                    />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems titulo="Histórico" valor={detalhe.historico || "-"} />
                </Grid>

                <Grid size={{xs: 6}}>
                    <DadosTitulosItems 
                        titulo="Localização banco" 
                        valor={detalhe.local_cobranca ? `${detalhe.local_cobranca?.codigo} - ${detalhe.local_cobranca?.nome}` : "-"} 
                    />
                </Grid>
            </Grid>

            {
                podeEditar &&
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={() => setOpenEdit(true)}
                    >
                        Editar
                    </Button>
                </Stack>
            }

            {
                openEdit &&
                <DialogEdit
                    {...{ codigo }}
                    open={openEdit}
                    handleClose={() => setOpenEdit(false)}
                    titulo={detalhe}
                />
            }
        </Box>
    )
}

interface CardDadosTituloProps {
    boxStyle: BoxProps,
    codigo: string,
    detalhe: IDetalharTituloPagar
}